import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6743a862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__content" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-space-between"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Withdraw", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "General Information", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.route.name == 'walletTransactionList')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_input, {
              class: "body__form__searchInput",
              clearable: "",
              modelValue: _ctx.searchForm.search_text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.search_text) = $event)),
              placeholder: "Search code / type / description",
              "value-key": "name"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Search)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.route.name == 'walletTransaction_withdraw')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.route.name == 'walletTransactionDetail')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}